import i18n from '@/lang/i18n'
import { HelperUtils } from '@/shared/util/helper-utils'
import { REQUEST_STATES } from '@/api/resources/entityState/request-state'
import { RequestOperation } from '@/api/operations/models/request-operation'

class ContextMenuFactory {
    getMenuItems({ api, node }, actions) {
        if (api.getSelectedRows().length > 1) {
            return this.getSelectionMenuItems(api.getSelectedRows(), actions)
        }
        return this.getSingleNodeMenuItems(node.data, actions)
    }
    getSingleNodeMenuItems(studyRequest, actions) {
        const notHaveCreateOperation = !HelperUtils.hasLabOperation(studyRequest.laboratory.labId, RequestOperation.CREATE)
        const notHaveCancelOperation = !HelperUtils.hasLabOperation(studyRequest.laboratory.labId, RequestOperation.PETITIONER_CANCEL)
        return [
            {
                name: i18n.tc('studyRequest.contextMenu.create'),
                action: actions.create,
                cssClasses: notHaveCreateOperation ? ['not-show'] : ''
            },
            {
                name: i18n.tc('studyRequest.contextMenu.edit'),
                action: actions.edit,
                cssClasses: studyRequest.status.code !== REQUEST_STATES.DRAFT.code || notHaveCreateOperation ? ['not-show'] : ''
            },
            {
                name: i18n.tc('studyRequest.contextMenu.cancel'),
                action: actions.cancel,
                cssClasses: !studyRequest.metadata.operationGuards.canBeCancelled || notHaveCancelOperation ? ['not-show'] : ''
            },
            {
                name: i18n.tc('component.studyRequest.form.discardDraft'),
                action: actions.discard,
                cssClasses: !studyRequest.metadata.operationGuards.canBeDeleted || notHaveCreateOperation ? ['not-show'] : ''
            },
            {
                name: i18n.t('studyRequest.contextMenu.addFile'),
                action: actions.addFile,
                cssClasses: ![REQUEST_STATES.DRAFT.code].includes(studyRequest.status.code) ||
                            !HelperUtils.hasLabOperation(studyRequest.laboratory.labId, RequestOperation.ATTACH) ? ['not-show'] : ''
            },
            this.getPrintSubMenu(studyRequest, actions)
        ]
    }
    getPrintSubMenu(studyRequest, actions) {
        const notHavePrintLabelsOperation = !HelperUtils.hasLabOperation(studyRequest.laboratory.labId, RequestOperation.PRINT_REQUEST_AND_LABELS)
        return {
            name: i18n.t('global.print'),
            cssClasses: notHavePrintLabelsOperation ? ['not-show'] : '',
            subMenu: [
                {
                    name: i18n.tc('global.request'),
                    action: actions.printReport,
                    cssClasses: notHavePrintLabelsOperation ? ['not-show'] : ''
                },
                {
                    name: i18n.tc('studyRequest.contextMenu.label', 2),
                    action: actions.printLabels,
                    cssClasses: notHavePrintLabelsOperation ? ['not-show'] : ''
                },
                {
                    name: i18n.tc('studyRequest.contextMenu.requestAndLabels'),
                    action: actions.printReportAndLabels,
                    cssClasses: notHavePrintLabelsOperation ? ['not-show'] : ''
                },
                {
                    name: i18n.t('global.report'),
                    action: actions.printCaseReport,
                    cssClasses: studyRequest.status.code !== REQUEST_STATES.COMPLETED.code || notHavePrintLabelsOperation ? ['not-show'] : ''
                }
            ]
        }
    }
    getSelectionMenuItems(studyRequests, actions) {
        const notHaveCreateOperation = !studyRequests.find(study => HelperUtils.hasLabOperation(study.laboratory.labId, RequestOperation.CREATE))
        const notHaveCancelOperation = !studyRequests.find(study => HelperUtils.hasLabOperation(study.laboratory.labId, RequestOperation.PETITIONER_CANCEL))
        return [
            {
                name: i18n.t('studyRequest.contextMenu.cancelRequests'),
                action: actions.batchCancel,
                cssClasses: !studyRequests.every(request => request.metadata.operationGuards.canBeCancelled) || notHaveCancelOperation ? ['not-show'] : ''
            },
            {
                name: i18n.tc('component.studyRequest.form.discardDrafts'),
                action: actions.batchDiscard,
                cssClasses: !studyRequests.every(request => request.metadata.operationGuards.canBeDeleted) || notHaveCreateOperation ? ['not-show'] : ''
            }
        ]
    }
}

export default new ContextMenuFactory()
